import type { RouteRecordRaw } from "vue-router";
import AccountPage from "./AccountPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/account",
    name: "account",
    component: AccountPage,
  },
];

export default routes;
